// import { Component, OnInit } from '@angular/core';
// import { Constants } from '../Services/Constants';
// import { HTTPService } from '../Services/http.service';
// import { Observable } from 'rxjs/Observable';
// import { filter } from '../App/search.pipe';
// import { MySharedService } from '../App/shared.service';

// declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
// @Component({
//     templateUrl: './AppViews/TaskType/taskType.html'
// })

// export class TaskTypeComponent implements OnInit {
//     userDetail: any;
//     public constants: Constants;
//     public taskType: any[] = [];
//     public taskGroups: any[] = [];
//     public taskTypeStatus: any[] = [];
//     public filterTaskTypeStatus: any = "";
//     public filterIsActiveStatus: any = "";
//     public Search: any = "";
//     public addTaskTypeData: any = { addTaskTypeGroup: "" };
//     public editTaskTypeData: any = { editTaskTypeGroup: "" };
//     public isAdd: boolean = true;
//     active = true;
//     public showLoader = false;
//     public existsTaskTypeName: boolean = false;
//     public isFormSubmitted: boolean = false;

//     constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
//         this.constants = new Constants();
//         this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
//         this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
//     }

//     newForm() {
//         this.active = false;
//         setTimeout(() => this.active = true, 0);
//     }

//     ngOnInit() {
//         this.GetTaskGroup();
//         this.GetStatus();
//         this.GetTaskType();
//     }

//     public AddTaskTypeFormLoad() {
//         $('#btnAddTaskTypeForm').trigger('click');
//         setTimeout(() => this.addTaskTypeData.addTaskTypeIsActive = true, 0);
//     }

//     public ResetForm(form: any) {
//         form.reset();
//         form.resetForm();
//         this.isFormSubmitted = false;
//     }

//     ExportItems() {
//         ExportToExcel(this.taskType, "TaskType",
//             ["TaskTypeName", "TaskDescription", "TaskGroupName", "Status"],
//             ["TaskType Name", "Task Description", "TaskGroup Name", "Status"]);
//     }
//     ngAfterViewInit() {
//         $("#show-filter").click(function () { $(".filter-form").slideToggle() });
//     }

//     public GetTaskGroup() {
//         this.showLoader = true;
//         this._httpService.ajaxPost('TaskGroup/GetTaskList', null).subscribe(
//             data => {
//                 this.taskGroups = data["taskList"];
//             },
//             err => {
//                 this.showLoader = false;
//                 this._sharedService.ShowMessage(this.constants.globalError);
//             },

//             () => {
//                 this.showLoader = false;

//             }
//         );
//     }
//     public GetStatus() {
//         this.showLoader = true;
//         this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
//             data => {
//                 this.taskTypeStatus = data["Parameter"];
//             },
//             err => {
//                 this.showLoader = false;
//                 this._sharedService.ShowMessage(this.constants.globalError);
//             },

//             () => {
//                 this.showLoader = false;

//             }
//         );
//     }

//     public GetTaskType() {
//         this.showLoader = true;
//         this._httpService.ajaxPost('TaskType/GetTaskType', { "TaskTypeId": 0, "TaskGroupId": this.filterTaskTypeStatus, "IsActive": this.filterIsActiveStatus }).subscribe(
//             data => {
//                 this.taskType = data["TaskType"];
//             },
//             err => {
//                 this.showLoader = false;
//                 this._sharedService.ShowMessage(this.constants.globalError);
//             },
//             () => {
//                 this.showLoader = false;
//             }
//         );
//     }

//     public clearFilter() {
//         this.filterTaskTypeStatus = "";
//         this.Search = "";
//         this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
//     }

//     public CancelAddTaskType() {
//         this.existsTaskTypeName = false;
//         this.addTaskTypeData = { addTaskTypeGroup: "" };
//         this.newForm();
//         $('#addTaskType').modal('hide');
//         this.isAdd = true;
//     }

//     public CancelEditTask() {
//         this.existsTaskTypeName = false;
//         this.editTaskTypeData = {};
//         this.newForm();
//         $('#editTaskType').modal('hide');
//         this.isAdd = true;
//     }

//     public AddTaskType(form: any) {
//         this.isFormSubmitted = true;
//         if (form.form.valid) {
//             this.existsTaskTypeName = false;
//             this.taskType.forEach(element => {
//                 if (element.TaskGroupId == this.addTaskTypeData.addTaskTypeGroup && element.TaskTypeName.trim().toLowerCase() == this.addTaskTypeData.addTaskTypeName.trim().toLowerCase()) {
//                     this.existsTaskTypeName = true;
//                 }
//             })

//             if (!this.existsTaskTypeName) {
//                 let objItem: any = {};
//                 objItem.TaskTypeId = 0;
//                 objItem.TaskGroupId = this.addTaskTypeData.addTaskTypeGroup;
//                 objItem.TaskTypeName = this.addTaskTypeData.addTaskTypeName;
//                 objItem.TaskDescription = this.addTaskTypeData.addTaskTypeDescription;
//                 objItem.IsActive = this.addTaskTypeData.addTaskTypeIsActive;
//                 objItem.Created_By = this.userDetail.SiteUserId;
//                 objItem.Modified_By = this.userDetail.SiteUserId;
//                 this.addEditTaskType(objItem);
//                 $('#addTaskType').modal('hide');
//                 this.newForm();
//                 this.addTaskTypeData = { addTaskTypeGroup: "" };
//                 this.isAdd = true;
//             }
//         }
//     }

//     public EditTaskType(item: any) {
//         $('#btnEditTaskTypeForm').trigger('click');
//         this.isAdd = false;
//         this.EditTaskTypeChange(item.TaskTypeId);

//     }
//     public EditTaskTypeChange(itemId) {
//         let objItem: any = {};
//         objItem = JSON.parse(JSON.stringify(this.taskType.filter((taskType) => taskType.TaskTypeId == itemId)[0]));
//         this.editTaskTypeData.editTaskGroupId = objItem.TaskGroupId;
//         this.editTaskTypeData.editTaskTypeId = objItem.TaskTypeId;
//         this.editTaskTypeData.editTaskTypeName = objItem.TaskTypeName;
//         this.editTaskTypeData.editTaskDescription = objItem.TaskDescription;
//         this.editTaskTypeData.editTaskIsActive = objItem.IsActive;
//     }

//     public UpdateTaskType(form: any) {
//         this.isFormSubmitted = true;
//         if (form.form.valid) {
//             this.existsTaskTypeName = false;
//             this.taskType.forEach(element => {
//                 if (element.TaskTypeId != this.editTaskTypeData.editTaskTypeId && element.TaskGroupId == this.editTaskTypeData.editTaskGroupId && element.TaskTypeName.trim().toLowerCase() == this.editTaskTypeData.editTaskTypeName.trim().toLowerCase()) {
//                     this.existsTaskTypeName = true;
//                 }
//             })

//             if (!this.existsTaskTypeName) {
//                 let objItem: any = {};
//                 objItem.TaskTypeId = this.editTaskTypeData.editTaskTypeId;
//                 objItem.TaskGroupId = this.editTaskTypeData.editTaskGroupId;
//                 objItem.TaskTypeName = this.editTaskTypeData.editTaskTypeName;
//                 objItem.TaskDescription = this.editTaskTypeData.editTaskDescription;
//                 objItem.IsActive = this.editTaskTypeData.editTaskIsActive;
//                 objItem.Created_By = this.userDetail.SiteUserId;
//                 objItem.Modified_By = this.userDetail.SiteUserId;
//                 this.addEditTaskType(objItem);
//                 $('#editTaskType').modal('hide');
//                 this.newForm();
//                 this.editTaskTypeData = {};
//                 this.isAdd = true;
//             }
//         }
//     }

//     addEditTaskType(objItem) {
//         this.showLoader = true;
//         this._httpService.ajaxPost('TaskType/AddUpdateTaskType', objItem).subscribe(
//             data => {
//                 var msg = data["Status"].Message.split('|');
//                 if (msg.length > 1) {
//                     msg[0] = msg[0].toLowerCase();
//                     this._sharedService.ShowMessage(data["Status"].Message);
//                 }
//                 else {
//                     this._sharedService.ShowMessage(data["Status"].Message);
//                 }
//                 this.GetTaskType();
//             },
//             err => {
//                 this.showLoader = false;
//                 this._sharedService.ShowMessage(this.constants.globalError);
//             },
//             () => {
//                 this.showLoader = false;
//             }
//         );
//     }

//     public openFileDialog() {
//         $("#TaskProcedure").trigger("click");
//     }
// }

import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
@Component({
    templateUrl: './AppViews/TaskType/taskType.html'
})

export class TaskTypeComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public taskType: any[] = [];
    public taskGroups: any[] = [];
    public taskGroupList: any[]=[];
    public taskTypeStatus: any[] = [];
    public filterTaskTypeStatus: any = "";
    public filterIsActiveStatus: any = "";
    public Search: any = "";
    public addTaskTypeData: any = { addTaskTypeGroup: "" };
    public editTaskTypeData: any = { editTaskTypeGroup: "" };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsTaskTypeName: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.GetTaskGroup();
        this.GetTaskGroupList();
        this.GetStatus();
        this.GetTaskType();
    }

    public AddTaskTypeFormLoad() {
        $('#btnAddTaskTypeForm').trigger('click');
        setTimeout(() => this.addTaskTypeData.addTaskTypeIsActive = true, 0);
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    ExportItems() {
        ExportToExcel(this.taskType, "TaskType",
            ["TaskTypeName", "TaskDescription", "TaskGroupName", "Status"],
            ["TaskType Name", "Task Description", "TaskGroup Name", "Status"]);
    }
    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public GetTaskGroup() {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskGroup/GetTaskList', null).subscribe(
            data => {
                this.taskGroups = data["taskList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;

            }
        );
    }

  public GetTaskGroupList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetTaskGroupList', {"TaskTypeId": 0, "TaskGroupId":0}).subscribe(
            data => {
                this.taskGroupList = data["TaskGroupList"];
                console.log(this.taskGroupList);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
                

            }
        );
    }

    public GetStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.taskTypeStatus = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;

            }
        );
    }

    public GetTaskType() {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskType/GetTaskType', { "TaskTypeId": 0, "TaskGroupId": this.filterTaskTypeStatus, "IsActive": this.filterIsActiveStatus }).subscribe(
            data => {
                this.taskType = data["TaskType"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public clearFilter() {
        this.filterTaskTypeStatus = "";
        this.Search = "";
        this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
    }

    public CancelAddTaskType() {
        this.existsTaskTypeName = false;
        this.addTaskTypeData = { addTaskTypeGroup: "" };
        this.newForm();
        $('#addTaskType').modal('hide');
        this.isAdd = true;
    }

    public CancelEditTask() {
        this.existsTaskTypeName = false;
        this.editTaskTypeData = {};
        this.newForm();
        $('#editTaskType').modal('hide');
        this.isAdd = true;
    }

    public AddTaskType(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsTaskTypeName = false;
            this.taskType.forEach(element => {
                if (element.TaskGroupId == this.addTaskTypeData.addTaskTypeGroup && element.TaskTypeName.trim().toLowerCase() == this.addTaskTypeData.addTaskTypeName.trim().toLowerCase()) {
                    this.existsTaskTypeName = true;
                }
            })

            if (!this.existsTaskTypeName) {
                let objItem: any = {};
                objItem.TaskTypeId = 0;
                objItem.TaskGroupId = this.addTaskTypeData.addTaskTypeGroup;
                objItem.TaskTypeName = this.addTaskTypeData.addTaskTypeName;
                objItem.TaskDescription = this.addTaskTypeData.addTaskTypeDescription;
                objItem.IsActive = this.addTaskTypeData.addTaskTypeIsActive;
                objItem.Created_By = this.userDetail.SiteUserId;
                objItem.Modified_By = this.userDetail.SiteUserId;
                this.addEditTaskType(objItem);
                $('#addTaskType').modal('hide');
                this.newForm();
                this.addTaskTypeData = { addTaskTypeGroup: "" };
                this.isAdd = true;
            }
        }
    }

    public EditTaskType(item: any) {
        $('#btnEditTaskTypeForm').trigger('click');
        this.isAdd = false;
        this.EditTaskTypeChange(item.TaskTypeId);

    }
    public EditTaskTypeChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.taskType.filter((taskType) => taskType.TaskTypeId == itemId)[0]));
        this.editTaskTypeData.editTaskGroupId = objItem.TaskGroupId;
        this.editTaskTypeData.editTaskTypeId = objItem.TaskTypeId;
        this.editTaskTypeData.editTaskTypeName = objItem.TaskTypeName;
        this.editTaskTypeData.editTaskDescription = objItem.TaskDescription;
        this.editTaskTypeData.editTaskIsActive = objItem.IsActive;
    }

    public UpdateTaskType(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsTaskTypeName = false;
            this.taskType.forEach(element => {
                if (element.TaskTypeId != this.editTaskTypeData.editTaskTypeId && element.TaskGroupId == this.editTaskTypeData.editTaskGroupId && element.TaskTypeName.trim().toLowerCase() == this.editTaskTypeData.editTaskTypeName.trim().toLowerCase()) {
                    this.existsTaskTypeName = true;
                }
            })

            if (!this.existsTaskTypeName) {
                let objItem: any = {};
                objItem.TaskTypeId = this.editTaskTypeData.editTaskTypeId;
                objItem.TaskGroupId = this.editTaskTypeData.editTaskGroupId;
                objItem.TaskTypeName = this.editTaskTypeData.editTaskTypeName;
                objItem.TaskDescription = this.editTaskTypeData.editTaskDescription;
                objItem.IsActive = this.editTaskTypeData.editTaskIsActive;
                objItem.Created_By = this.userDetail.SiteUserId;
                objItem.Modified_By = this.userDetail.SiteUserId;
                this.addEditTaskType(objItem);
                $('#editTaskType').modal('hide');
                this.newForm();
                this.editTaskTypeData = {};
                this.isAdd = true;
            }
        }
    }

    addEditTaskType(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskType/AddUpdateTaskType', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.GetTaskType();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public openFileDialog() {
        $("#TaskProcedure").trigger("click");
    }
}




/** WEBPACK FOOTER **
 ** ./TypeScripts/TaskType/taskType.component.ts
 **/